import createIcon from '../../createIcon';

/**
 * @component @name ZoomIn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzU0OSAxNC4yNTQ5SDE0Ljk2NDlMMTQuNjg0OSAxMy45ODQ5QzE1LjY2NDkgMTIuODQ0OSAxNi4yNTQ5IDExLjM2NDkgMTYuMjU0OSA5Ljc1NDg4QzE2LjI1NDkgNi4xNjQ4OCAxMy4zNDQ5IDMuMjU0ODggOS43NTQ4OCAzLjI1NDg4QzYuMTY0ODggMy4yNTQ4OCAzLjI1NDg4IDYuMTY0ODggMy4yNTQ4OCA5Ljc1NDg4QzMuMjU0ODggMTMuMzQ0OSA2LjE2NDg4IDE2LjI1NDkgOS43NTQ4OCAxNi4yNTQ5QzExLjM2NDkgMTYuMjU0OSAxMi44NDQ5IDE1LjY2NDkgMTMuOTg0OSAxNC42ODQ5TDE0LjI1NDkgMTQuOTY0OVYxNS43NTQ5TDE5LjI1NDkgMjAuNzQ0OUwyMC43NDQ5IDE5LjI1NDlMMTUuNzU0OSAxNC4yNTQ5Wk05Ljc1NDg4IDE0LjI1NDlDNy4yNjQ4OCAxNC4yNTQ5IDUuMjU0ODggMTIuMjQ0OSA1LjI1NDg4IDkuNzU0ODhDNS4yNTQ4OCA3LjI2NDg4IDcuMjY0ODggNS4yNTQ4OCA5Ljc1NDg4IDUuMjU0ODhDMTIuMjQ0OSA1LjI1NDg4IDE0LjI1NDkgNy4yNjQ4OCAxNC4yNTQ5IDkuNzU0ODhDMTQuMjU0OSAxMi4yNDQ5IDEyLjI0NDkgMTQuMjU0OSA5Ljc1NDg4IDE0LjI1NDlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIuMjU0OSAxMC4yNTQ5SDEwLjI1NDlWMTIuMjU0OUg5LjI1NDg4VjEwLjI1NDlINy4yNTQ4OFY5LjI1NDg4SDkuMjU0ODhWNy4yNTQ4OEgxMC4yNTQ5VjkuMjU0ODhIMTIuMjU0OVYxMC4yNTQ5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ZoomIn = createIcon('ZoomIn', [
  [
    'path',
    {
      d: 'M15.7549 14.2549H14.9649L14.6849 13.9849C15.6649 12.8449 16.2549 11.3649 16.2549 9.75488C16.2549 6.16488 13.3449 3.25488 9.75488 3.25488C6.16488 3.25488 3.25488 6.16488 3.25488 9.75488C3.25488 13.3449 6.16488 16.2549 9.75488 16.2549C11.3649 16.2549 12.8449 15.6649 13.9849 14.6849L14.2549 14.9649V15.7549L19.2549 20.7449L20.7449 19.2549L15.7549 14.2549ZM9.75488 14.2549C7.26488 14.2549 5.25488 12.2449 5.25488 9.75488C5.25488 7.26488 7.26488 5.25488 9.75488 5.25488C12.2449 5.25488 14.2549 7.26488 14.2549 9.75488C14.2549 12.2449 12.2449 14.2549 9.75488 14.2549Z',
      key: '1ac8z8',
    },
  ],
  [
    'path',
    {
      d: 'M12.2549 10.2549H10.2549V12.2549H9.25488V10.2549H7.25488V9.25488H9.25488V7.25488H10.2549V9.25488H12.2549V10.2549Z',
      key: '1l6oga',
    },
  ],
]);

export default ZoomIn;
